import Vue from 'vue'
import selectInput from './common/selectInput'
import rangePicker from './common/rangePicker'
import treeSelect from './common/treeSelect'
Vue.component('select-input', selectInput);
Vue.component('range-picker', rangePicker);
Vue.component('tree-select', treeSelect);